<div class="field-dashboard-main-container">
  <div class="tab-navigation-container">
    <div class="tabs-left">
      <a class="tab-link" routerLink="analysis" routerLinkActive="active-tab">Field Analysis</a>
      <!-- <a class="tab-link" routerLink="cost-breakdown" routerLinkActive="active-tab">Cost Breakdown</a> -->
    </div>
    <div class="date-range-right">
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>Season</mat-label>
        <mat-select [(value)]="selectedSeason" (selectionChange)="onSeasonChange()">
          <mat-option *ngFor="let season of seasons" [value]="season">{{ season }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate" (dateChange)="onDateChange()" [max]="endDate">
        <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate" (dateChange)="onDateChange()" [min]="startDate">
        <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
